const isTestEnv = window?.location?.host?.includes("test");

export const BASE_URL = process.env.REACT_APP_BACKEND_URL
  ? process.env.REACT_APP_BACKEND_URL
  : isTestEnv
  // ? "https://testapi.smilingss.com"
  // : "https://api.smilingss.com";
